import vue from "../main";

export const transportType = Object.freeze({
  TRANSPORT_CAR: 1,
  TRANSPORT_CAR_RENTAL: 8,
  TRANSPORT_FLIGHT: 2,
  TRANSPORT_RAIL: 3,
  TRANSPORT_PKS: 4,
  TRANSPORT_BUS: 5,
  TRANSPORT_PUBLIC_LOCAL: 6,
  TRANSPORT_OTHER: 7
});

export const allTransportTypes = () => {
  let sorted = [
    { id: transportType.TRANSPORT_CAR, name: vue.$t("$staticData.transportTypes.car") },
    { id: transportType.TRANSPORT_CAR_RENTAL, name: vue.$t("$staticData.transportTypes.carRental") },
    { id: transportType.TRANSPORT_FLIGHT, name: vue.$t("$staticData.transportTypes.flight") },
    { id: transportType.TRANSPORT_RAIL, name: vue.$t("$staticData.transportTypes.rail") },
    { id: transportType.TRANSPORT_PKS, name: vue.$t("$staticData.transportTypes.pks") },
    { id: transportType.TRANSPORT_BUS, name: vue.$t("$staticData.transportTypes.bus") },
    { id: transportType.TRANSPORT_PUBLIC_LOCAL, name: vue.$t("$staticData.transportTypes.publicTransport") }
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
  sorted.push({ id: transportType.TRANSPORT_OTHER, name: vue.$t("$staticData.transportTypes.other") });
  return sorted;
};

export default function() {
  let allowedTransportTypes = JSON.parse(vue.$store.state.Auth.userProperties.system_settings.allowed_transport_types);
  return allTransportTypes().filter(row => allowedTransportTypes.includes(row.id));
}
